(() => {
  function init(root) {
    if (root.dataset.scrollReady || !('IntersectionObserver' in window)) return;
    const grid = root.querySelector('.futur-collection__grid');
    const loader = root.querySelector('[data-futur-load]');
    if (!grid || !loader) return;
    root.dataset.scrollReady = 'true';
    root.classList.add('is-infinite');
    const status = loader.querySelector('[data-futur-load-status]');
    const retry = loader.querySelector('[data-futur-load-retry]');
    const initialPage = Number(loader.dataset.page);
    const storageKey = 'futur-collection-scroll:' + location.pathname + location.search;
    const seen = new Set([...grid.querySelectorAll('[data-futur-product-id]')].map(item => item.dataset.futurProductId));
    const visited = new Set();
    let next = loader.dataset.nextUrl;
    let page = initialPage;
    let busy = false;
    let failed = false;
    let restoring = false;
    let restored = null;
    const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (back) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (saved && Date.now() - saved.time < 1800000) restored = saved;
      } catch (_) {}
    }
    function save() {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ page, scroll: window.scrollY, time: Date.now() })); } catch (_) {}
    }
    window.addEventListener('pagehide', save);
    function readyImages(scope) {
      scope.querySelectorAll('.futur-card__secondary').forEach(image => {
        const ready = () => { if (image.naturalWidth) image.closest('.futur-card').classList.add('futur-card--ready'); };
        if (image.complete) ready(); else image.addEventListener('load', ready, { once: true });
      });
    }
    function nearEnd() {
      const rect = loader.getBoundingClientRect();
      return rect.top <= window.innerHeight + 500 && rect.bottom >= 0;
    }
    async function load() {
      if (busy || !next || failed) return false;
      const url = new URL(next, location.href);
      if (url.origin !== location.origin || visited.has(url.href)) {
        next = '';
        return false;
      }
      busy = true;
      status.textContent = 'Laster flere produkter …';
      grid.setAttribute('aria-busy', 'true');
      retry.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const request = new URL(url);
        request.searchParams.set('section_id', root.dataset.futurInfinite);
        const response = await fetch(request, { signal: controller.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('[data-futur-infinite]');
        const incomingGrid = section?.querySelector('.futur-collection__grid');
        const incomingLoader = section?.querySelector('[data-futur-load]');
        if (!incomingGrid || !incomingLoader) throw new Error('Collection response missing');
        const fragment = document.createDocumentFragment();
        for (const item of incomingGrid.querySelectorAll(':scope > li[data-futur-product-id]')) {
          const id = item.dataset.futurProductId;
          if (seen.has(id)) continue;
          seen.add(id);
          item.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });
          fragment.append(item);
        }
        grid.append(fragment);
        readyImages(grid);
        visited.add(url.href);
        next = incomingLoader.dataset.nextUrl;
        page = Number(incomingLoader.dataset.page);
        loader.dataset.nextUrl = next;
        loader.dataset.page = String(page);
        status.textContent = next ? '' : 'Alle produktene er vist.';
        return true;
      } catch (_) {
        failed = true;
        status.textContent = 'Kunne ikke laste flere produkter.';
        retry.hidden = false;
        root.classList.remove('is-infinite');
        return false;
      } finally {
        clearTimeout(timeout);
        busy = false;
        grid.removeAttribute('aria-busy');
        if (!restoring && !failed && next) requestAnimationFrame(() => { if (nearEnd()) load(); });
      }
    }
    retry.addEventListener('click', () => {
      failed = false;
      root.classList.add('is-infinite');
      load();
    });
    root.querySelector('.futur-collection__top')?.addEventListener('click', event => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      root.querySelector('h1')?.setAttribute('tabindex', '-1');
      root.querySelector('h1')?.focus({ preventScroll: true });
    });
    async function start() {
      restoring = true;
      if (restored) {
        while (page < restored.page && next && !failed) {
          if (!await load()) break;
        }
        requestAnimationFrame(() => window.scrollTo({ top: restored.scroll, behavior: 'auto' }));
      }
      restoring = false;
      if (!next) status.textContent = 'Alle produktene er vist.';
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !restoring) load();
      }, { rootMargin: '500px 0px' });
      observer.observe(loader);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) {
          observer.disconnect();
          window.removeEventListener('pagehide', save);
        }
      });
    }
    start();
  }
  document.querySelectorAll('[data-futur-infinite]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-futur-infinite]').forEach(init));
})();
